"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureViewAnimation = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
// import { moderateScale, scale } from "../../utils/scale";
const CustomText_1 = __importDefault(require("../text/CustomText"));
const scale_1 = require("../../utils/scale");
const images_1 = require("../../assets/images");
const NotiButtonImage_1 = __importDefault(require("./NotiButtonImage"));
const helpler_1 = require("../../utils/helpler");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../constants");
const getFeatureViewAnimation = (animatedValue, heightView, heightViewOne) => {
    // console.log(heightView);
    return {
        transform: [
            {
                translateY: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, -heightView + heightViewOne],
                    extrapolate: 'clamp',
                }),
            },
        ],
    };
};
exports.getFeatureViewAnimation = getFeatureViewAnimation;
const NotiButton = ({ data, isVisible, height, index, heightViewOne, length, ReadNoti, }) => {
    const fadValue = (0, react_1.useRef)(new react_native_1.Animated.Value(1)).current;
    const animatedValue = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const hideViewAnimation = (0, exports.getFeatureViewAnimation)(animatedValue, height, heightViewOne);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const Icon = () => {
        if (data?.reactionType == 1) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.FollowUse, style: styles.imageNoti });
        }
        else if (data?.reactionType == 2 || data?.reactionType == 4) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.LikeTweet, style: styles.imageNoti });
        }
        else if (data?.reactionType == 3) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.ReTweet, style: styles.imageNoti });
        }
        else if (data?.type == 2 && data?.userBulkNotificationId != null) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.Tweet, style: styles.imageNoti });
        }
        else if (data?.reactionType == 5) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.ArticleInh, style: styles.imageNoti });
        }
        else if ((data?.type == 3 || data?.type == 4) && data?.userBulkNotificationId != null) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.postAritcle, style: styles.imageNoti });
        }
        return null;
    };
    const navigateToUserProfile = (userHandle) => {
        if (data?.type == 1) {
            updateReadNotiFirebase();
        }
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: userHandle,
            },
        });
    };
    const checkComment = data?.reactionType == null && data?.userBulkNotificationId == null;
    const updateReadNotiFirebase = () => {
        if (react_native_1.Platform.OS === 'web' && data?.isRead == 0) {
            const { firebase } = require('../../../web/firebase/config');
            try {
                firebase
                    .firestore()
                    .collection('users')
                    .doc(dataUser?.user_id?.toString())
                    .collection('boxNotifications')
                    .doc(data?._id)
                    .update({ isRead: 1 });
                ReadNoti(data?._id);
            }
            catch (err) {
                console.log('err', err);
            }
        }
    };
    const onPressNoti = () => {
        const path = data?.path;
        let containsRelai = path?.indexOf('replies') != -1;
        let parts = '';
        let textAfterSlash = null;
        let textpath = 'tweets';
        if (containsRelai) {
            textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
            textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
        }
        else {
            parts = path.split('/');
            textAfterSlash = parts[1];
        }
        if (data?.reactionType == 2 && data?.type == 2) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                postId: (0, helpler_1.urlPost)(`${textpath}/${textAfterSlash}`),
            });
        }
        else if (data?.reactionType == 3 ||
            (data?.type == 2 && data?.userBulkNotificationId != null)) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                postId: (0, helpler_1.urlPost)(`${textpath}/${textAfterSlash}`),
            });
        }
        else if (data?.reactionType == 5 || data?.reactionType == 4) {
            const idArticle = data?.articleInheritedId ? data?.articleInheritedId : data.articleId;
            updateReadNotiFirebase();
            (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: idArticle });
        }
        else if ((data?.type == 3 || data?.type == 4) && data?.userBulkNotificationId != null) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: data.articleId });
        }
        else if (data?.type == 2 && checkComment) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                postId: (0, helpler_1.urlPost)(`${textpath}/${textAfterSlash}`),
            });
        }
        else if ((data?.type == 3 || data?.type == 4) &&
            checkComment &&
            data?.articleCommentId == null) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.navigate)(Routes_1.default.LIST_COMMENT_ARTICLE, {
                articleId: data?.articleId,
            });
        }
        else if ((data?.type == 3 || data?.type == 4) && checkComment && data?.articleCommentId) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.push)(Routes_1.default.DETAIL_COMMENT_ARTICLE, {
                postId: data?.articleCommentId,
                articleId: data?.articleId,
            });
        }
        else if (data?.type == 9) {
            updateReadNotiFirebase();
            (0, rootNavigation_1.push)(Routes_1.default.DETAIL_NOTI_SCREEN, { idNoti: data?._id });
        }
    };
    const mainText = () => {
        if ((data?.type == 2 && (data?.reactionType == 3 || data?.reactionType == 2)) ||
            data?.reactionType == 5 ||
            data?.type == 1 ||
            data?.reactionType == 4) {
            if (data?.mainText?.includes('と他xx人')) {
                if (data?.others == 0) {
                    const replacedText = data?.mainText?.replace('と他xx人', '');
                    return replacedText;
                }
                else if (data?.others > 0) {
                    const replacedText = data?.mainText?.replace('と他xx人', `と他${data?.others}人`);
                    return replacedText;
                }
            }
        }
        return data?.mainText;
    };
    (0, react_1.useEffect)(() => {
        react_native_1.Animated.timing(animatedValue, {
            toValue: isVisible ? 1 : 0,
            duration: 500,
            useNativeDriver: true,
        }).start();
        react_native_1.Animated.timing(fadValue, {
            toValue: isVisible ? 0 : 1,
            duration: 500,
            useNativeDriver: true,
        }).start();
    }, [isVisible, hideViewAnimation]);
    const listDataUser = data?.reactionUsers?.length > 0 ? data?.reactionUsers?.reverse() : [];
    const titleNoti = () => {
        if (data?.type == 2) {
            return 'タイムライン';
        }
        else if (data?.type == 3) {
            return '記事';
        }
        else if (data?.type == 1) {
            return 'アカウント';
        }
        else if (data?.type == 4) {
            return '自分史';
        }
        else if (data?.type == 9) {
            return '運営からのお知らせ';
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        index == 0 && isVisible && (react_1.default.createElement(NotiButtonImage_1.default, { data: data, time: (0, helpler_1.stringToDateFormat)(data?.createdAt), isVisible: isVisible, length: length })),
        !isVisible && (react_1.default.createElement(react_native_1.Animated.View, { style: [
                styles.notification,
                hideViewAnimation,
                { opacity: fadValue },
                { backgroundColor: data?.isRead == 0 ? 'white' : '#EDEDED' },
            ] },
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                    onPressNoti();
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        color: '#545454',
                        fontSize: (0, scale_1.moderateScale)(12),
                        marginBottom: (0, scale_1.scale)(8),
                    } }, titleNoti()),
                react_1.default.createElement(react_native_1.View, { style: styles.notiTitle },
                    checkComment && data?.type != 9 ? (react_1.default.createElement(react_native_1.View, { style: styles.notiTitleChild },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => navigateToUserProfile(data?.reactionUsers[0]?.userHandle) },
                            react_1.default.createElement(react_native_1.Image, { source: data?.reactionUsers[0]?.thumbnailUrl
                                    ? data?.reactionUsers[0]?.thumbnailUrl
                                    : images_1.images.AvatarDefaul, style: {
                                    height: (0, scale_1.scale)(42),
                                    width: (0, scale_1.scale)(42),
                                    borderRadius: 99,
                                } })),
                        react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(200) } },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDes, { maxWidth: (0, scale_1.scale)(200) }], numberOfLines: 1 }, data?.reactionUsers[0]?.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDate, { maxWidth: (0, scale_1.scale)(200) }], numberOfLines: 1 }, data?.reactionUsers[0]?.userHandle
                                ? `@${data?.reactionUsers[0]?.userHandle}`
                                : '')))) : (react_1.default.createElement(react_native_1.View, { style: {
                            flex: 1,
                            flexDirection: 'row',
                            alignItems: 'center',
                            columnGap: (0, scale_1.scale)(8),
                        } },
                        react_1.default.createElement(Icon, null),
                        listDataUser.map((item, index) => {
                            if (index >= 5)
                                return;
                            return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => navigateToUserProfile(item?.userHandle), key: index },
                                react_1.default.createElement(react_native_1.Image, { source: item?.thumbnailUrl
                                        ? item?.thumbnailUrl
                                        : images_1.images.AvatarDefaul, style: {
                                        height: (0, scale_1.scale)(32),
                                        width: (0, scale_1.scale)(32),
                                        borderRadius: 99,
                                    } })));
                        }))),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDate, { marginLeft: (0, scale_1.scale)(40) }] }, (0, helpler_1.stringToDateFormat)(data?.createdAt))),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDes, { marginLeft: checkComment ? (0, scale_1.scale)(50) : 0 }], numberOfLines: checkComment ? 1 : undefined }, checkComment ? data?.bottomText?.replace(/<[^>]*>/g, '') : mainText()),
                !checkComment && (react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.bottomText, numberOfLines: 1 }, data?.bottomText?.replace(/<[^>]*>/g, ''))))))));
};
const styles = react_native_1.StyleSheet.create({
    notification: {
        width: (0, scale_1.scale)(343),
        position: 'relative',
        padding: (0, scale_1.scale)(12),
        borderRadius: (0, scale_1.scale)(5),
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.08,
        shadowRadius: 4,
        elevation: 6,
        marginVertical: 5,
    },
    notiTitleChild: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        height: (0, scale_1.scale)(32),
        columnGap: (0, scale_1.scale)(8),
    },
    notiTitle: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: (0, scale_1.scale)(8),
        columnGap: (0, scale_1.scale)(8),
    },
    textTitle: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#292A33',
    },
    textDate: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#7C7C7C',
    },
    textDes: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    imageNoti: {
        width: (0, scale_1.scale)(32),
        height: (0, scale_1.scale)(32),
    },
    bottomText: {
        fontSize: (0, scale_1.moderateScale)(11),
        lineHeight: (0, scale_1.moderateScale)(19),
        color: '#999999',
    },
});
exports.default = NotiButton;
